import { Box, Flex, Portal } from "@chakra-ui/react";
import { MapContainer, ScaleControl, ZoomControl } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import "./styles.css";
import Spritesheet from "../../../_assets/imgs/drawControl/spritesheet.png";
import Rule from "../../../_assets/imgs/measureControl/rule.png";
import PopupNotificationProvider from "./context/PopupNotificationProvider";
import { ControlPortal } from "./Controls/base/ControlPortal";
import { ClickPointControl } from "./Controls/ClickPointControl";
import { DrawControl } from "./Controls/DrawControl";
import { HomeControl } from "./Controls/HomeControl";
import { LabelControl } from "./Controls/LabelControl";
import { LayerControl } from "./Controls/LayerControl";
import { LegendControl } from "./Controls/LegendControl";
import { MeasureMapControl } from "./Controls/MeasureMapControl";
import { ZoomBoxControl } from "./Controls/ZoomBoxContainer";
import { memo, useRef } from "react";
import { BoundRedirector } from "./Controls/BoundRedirector";
import { LayerList } from "./Controls/LayerControl/components/LayerList";
import { StreetViewControl } from "./Controls/StreetViewControl";
import { PopupNotification } from "./PopupNotification";

type Props = {
  children?: React.ReactNode;
};

export const MapWrapper = ({ children }: Props) => {
  const boxPortalRef = useRef<HTMLDivElement>(null);

  return (
    <Flex
      className="react-leaflet-container"
      h="full"
      w="full"
      sx={{
        ".leaflet-bar a, .leaflet-bar,  .leaflet-bar:not(.leaflet-draw-toolbar):not(.leaflet-popup-notice) a:hover, .leaflet-control-attribution, .leaflet-measure-resultpopup .leaflet-popup-content-wrapper":
          {
            bgColor: "white",
            color: "gray.600"
          },
        ".leaflet-popup-notice": {
          bgColor: "white"
        },
        ".leaflet-bar a:hover, .leaflet-bar button:hover": {
          color: "gray.800"
        },
        ".leaflet-bar a, .leaflet-bar a:hover": {
          borderBottomColor: "white"
        },
        ".leaflet-control-scale-line": {
          borderColor: "gray.600"
        },
        ".leaflet-draw-toolbar a": {
          backgroundImage: `url(${Spritesheet}) !important`
        },
        ".leaflet-control-measure-toggle": {
          backgroundImage: `url(${Rule}) !important`
        },
        ".label-only-text": {
          background: "transparent",
          border: 0,
          boxShadow: "none",
          fontWeight: "medium",
          color: "black"
        },
        ".box": {
          display: "flex",
          flexDirection: "row"
        }
      }}
    >
      <PopupNotificationProvider>
        <MapContainer
          style={{
            height: "100%",
            width: "100%"
          }}
          zoomControl={false}
          preferCanvas={true}
        >
          <BoundRedirector />
          <ZoomControl
            position="bottomright"
            zoomInTitle="Aumentar zoom"
            zoomOutTitle="Diminuir zoom"
          />
          <ZoomBoxControl position="bottomright" />
          <ScaleControl position="bottomleft" imperial={false} />
          <DrawControl position="topright" />
          <MeasureMapControl position="topright" />

          <LegendControl />

          <ControlPortal position="topright">
            <ClickPointControl />
            <LabelControl />
          </ControlPortal>

          <ControlPortal position="bottomleft">
            <LayerControl>
              <LayerList />
            </LayerControl>
          </ControlPortal>

          <ControlPortal position="bottomright">
            <StreetViewControl />
            {/* <VisibilityControl /> */}
            <HomeControl />
          </ControlPortal>
          <Portal containerRef={boxPortalRef}>{children}</Portal>
        </MapContainer>
        <PopupNotification />
        <Box className="react-leaflet-portal" ref={boxPortalRef} />
      </PopupNotificationProvider>
    </Flex>
  );
};

export const Map = memo(MapWrapper);
